import moment from "moment-timezone";

export default function getTimeIn12HourFormat(dateTimeString) {
  if (!dateTimeString) return null;
  const date = moment.utc(dateTimeString); // Parse as UTC
  return date.format("h:mm A"); // Format in 12-hour time
}
